<div class="symbols-wrapper">
  <img
    style="height: 50px; width: 50px"
    *ngFor="let symbol of symbols"
    [id]="symbol.id"
    [src]="symbol.imgSrc"
    class="img-fluid"
  />
</div>
